

const DEBUG = false;

import laziestloader from 'laziestloader';

export default class Lazyloader {

  setup() {
    this.process_images();
    document.addEventListener("content:changed", (e) => {
      this.process_images();
    });
  }
  process_images() {
    setImmediate(() => {
      $('.lazy-image').laziestloader();
    })
  }
}
